import React from 'react';
import cx from 'classnames';
import Modal from '../../Modal';
import styles from './SharingModal.module.scss';

function SharingModal(props) {
  const { open, onClose, children, ...rest } = props;

  return (
    <Modal className={cx(styles.sharingModal)} open={open} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
}

export default SharingModal;
